import Enum from './enum'

class TenderMethod extends Enum
{
  constructor(value) {
    super(value);
  }
}

TenderMethod.init({
  EMPTY: 'None',
  TENDER: 'Tender',
  REQUEST_FOR_PRICE: 'PriceInquiry',
  REQUEST_FOR_PROPOSALS: 'RequestForProposals',
  ONE: 'One',
  REDUCTION: 'ManyReduction'
}, {
  EMPTY: 'tender-method.empty',
  TENDER: 'tender-method.tender',
  REQUEST_FOR_PRICE: 'tender-method.request-for-price',
  REQUEST_FOR_PROPOSALS: 'tender-method.request-for-proposals',
  ONE: 'tender-method.one',
  REDUCTION: 'tender-method.reduction'
});

export default TenderMethod;
